// =============================================================================
// PAGES/OPERACAOPAGE.TSX - Página dedicada da operação (TO-BE, 07/09/2026)
// =============================================================================
// Rota /operacoes/:id. Substitui o popup (OperacaoModal em overlay) por uma página
// cheia, com botão "← Voltar" que retorna à origem (state.from) ou ao histórico.
// Fechar = navegar - o onUpdate assíncrono (ex.: marcarVisto) não reabre mais nada.
//
// Fonte de dados: SEMPRE getById(id) (detalhe completo, com documentos/tarefas/
// movimentacoes/timeline - o card do board é parcial e não basta para o modal).
// O `state.from` é a origem para o botão Voltar.
// =============================================================================

import { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import OperacaoModal from '../components/OperacaoModal';
import { operacoesApi } from '../services/api';
import type { Operacao } from '../types';

interface StateModalContent {
  from?: string;
}

export default function OperacaoPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as StateModalContent | null)?.from;
  // Aba inicial opcional via ?aba= (ex.: notificação de menção → aba Comentários)
  const abaInicial = new URLSearchParams(location.search).get('aba') ?? undefined;

  const [op, setOp] = useState<Operacao | null>(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    if (!id) {
      setErro('Operação não encontrada.');
      setCarregando(false);
      return;
    }
    let ativo = true;
    setCarregando(true);
    operacoesApi.getById(id)
      .then((d) => { if (ativo) setOp(d); })
      .catch(() => { if (ativo) setErro('Operação não encontrada.'); })
      .finally(() => { if (ativo) setCarregando(false); });
    return () => { ativo = false; };
  }, [id]);

  const voltar = () => {
    if (from) navigate(from);
    else navigate(-1);
  };

  return (
    <div className="h-full flex flex-col" style={{ backgroundColor: '#F7F8FA' }}>
      <main className="flex-1 flex flex-col min-h-0 overflow-hidden">
        {carregando ? (
          <div className="flex-1 flex items-center justify-center">
            <span className="text-slate-400 text-sm">Carregando operação…</span>
          </div>
        ) : erro ? (
          <div className="m-4 bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-2 rounded-lg">
            {erro}
          </div>
        ) : op ? (
          <OperacaoModal operacao={op} onClose={voltar} onUpdate={(novaOp) => setOp(novaOp)} abaInicial={abaInicial} />
        ) : null}
      </main>
    </div>
  );
}
